module.exports = __webpack_public_path__ + "img/small.1e08ccc4.png";